import { gql } from "@apollo/client";
import FormDialog from "controls/FormDialog";
import useData from "hooks/useData";
import { Plus } from "mdi-material-ui";
import React from "react";
import AddGameDialog from "readmin_pages/games/AddGameDialog";

GameScheduleAddMissingGameDialog.useButtonProps = ({ gameScheduleId }) => {
  const [data] = useData(
    gql`
      query GameScheduleAddMissingGameDialog($gameScheduleId: ID!) {
        gameSchedule(id: $gameScheduleId) {
          id
          missingGames
        }
      }
    `,
    { gameScheduleId },
  );

  return {
    hidden: !data?.gameSchedule.missingGames,
    icon: <Plus />,
    content: "Add Missing Game",
  };
};

export default function GameScheduleAddMissingGameDialog({ gameScheduleId, onSubmit, onClose }) {
  const [data, dataMeta] = useData(
    gql`
      query GameScheduleAddMissingGameDialog($gameScheduleId: ID!) {
        gameSchedule(id: $gameScheduleId) {
          id
          scheduledAt
          finishAt
          org {
            id
          }
          league {
            id
          }
          court {
            id
          }
          homeTeam {
            id
          }
          awayTeam {
            id
          }
        }
      }
    `,
    { gameScheduleId },
  );

  if (dataMeta.loading) return <FormDialog loading />;

  return (
    <AddGameDialog
      leagueId={data.gameSchedule.league.id}
      courtId={data.gameSchedule.court.id}
      homeId={data.gameSchedule.homeTeam.id}
      awayId={data.gameSchedule.awayTeam.id}
      playedAt={data.gameSchedule.scheduledAt}
      completedAt={data.gameSchedule.finishAt}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
}
